import { Box, chakra } from '@chakra-ui/react';
import React from 'react';

interface Props {
  className?: string;
}

const AdminSupportText = ({ className }: Props) => {
  return (
    <Box className={ className }>
      <span>如需帮助，请联系共生道 MTD 运营团队。</span>
    </Box>
  );
};

export default chakra(AdminSupportText);
